import React from 'react';
import { isMobile } from '../../unit';


export default class Guide extends React.Component {
  constructor() {
    super();
    this.state = {
      isMobile: isMobile(),
    };
  }
  render() {
    if (this.state.isMobile) {
      return (
        null
      );
    }
    return (
      null
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/guide/index.js